'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabSwitcher = _react2['default'].createClass({
    displayName: 'TabSwitcher',


    propTypes: {
        onNextClick: _react2['default'].PropTypes.func.isRequired,
        onPrevClick: _react2['default'].PropTypes.func.isRequired
    },

    onNextClick: function onNextClick() {
        this.props.onNextClick();
    },
    onPrevClick: function onPrevClick() {
        this.props.onPrevClick();
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            { className: 'hide-for-large-up' },
            _react2['default'].createElement(
                'div',
                { className: 'm-tabs--switcher right', onClick: this.onNextClick },
                _react2['default'].createElement('img', { className: 'm-tabs--right-arrow', src: require('./arrow_right@2x.png') })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-tabs--switcher left', onClick: this.onPrevClick },
                _react2['default'].createElement('img', { className: 'm-tabs--left-arrow', src: require('./arrow_left@2x.png') })
            )
        );
    }
});

module.exports = TabSwitcher;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/tabbed-area/tab-switcher.jsx
 ** module id = 1134
 ** module chunks = 0
 **/